var InvalidProductReasonEnum;
(function (InvalidProductReasonEnum) {
    // Sell-stopped
    InvalidProductReasonEnum["retailItemNotAvailable"] = "RETAIL_ITEM_NOT_AVAILABLE";
})(InvalidProductReasonEnum || (InvalidProductReasonEnum = {}));
export default InvalidProductReasonEnum;
//# sourceMappingURL=InvalidProductReasonEnum.js.map